import MyBowlerInfo from "../views/myinfo/MyBowlerInfo.vue";
import MyMatchInfo from "../views/myinfo/MyMatchInfo.vue";
import MyAccountStatement from "../views/myinfo/MyAccountStatement.vue";
import MyScore from "@/views/myinfo/MyScore.vue";
import MyIdCode from "@/views/myinfo/MyIdCode.vue";

const userRoutes = [
  {
    path: "/myBowlerInfo",
    name: "myBowlerInfo",
    component: MyBowlerInfo,
  },
  {
    path: "/myMatchInfo",
    name: "myMatchInfo",
    component: MyMatchInfo,
  },
  {
    path: "/myAccountStatement",
    name: "myAccountStatement",
    component: MyAccountStatement,
  },
  {
    path: "/myScore",
    name: "myScore",
    component: MyScore,
  },
  {
    path: "/MyIdCode",
    name: "MyIdCode",
    component: MyIdCode,
  },
];

export default userRoutes;
